import { Modal, ModalCloseButtonProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type ModalFormCloseButtonProps = ModalCloseButtonProps;

export const createModalFormCloseButton = () => {
	const ModalFormCloseButton = forwardRef<HTMLButtonElement, ModalFormCloseButtonProps>(
		({ className, children, ...props }, ref) => (
			<Modal.CloseButton
				ref={ref}
				data-test-id='modal-form-close-button'
				className={clsx('modal-form-close', className)}
				{...props}
			>
				{children}
			</Modal.CloseButton>
		),
	);

	return ModalFormCloseButton;
};
